import { useState, useEffect, useRef } from 'react';
import { IonModal, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';
import { person, close } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import axios from 'axios';
import Loading from '../../Loading';
import './Travelers.css';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    travelerParentCallback: Function
}
const Travelers = (props: Props) => {
    const profileTravelers = Constants.api.profileTravelers;
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showTravelersModal: false,
        token: '',
        errorMessage: '',
        travelers: []
    });
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    useEffect(() => {
        const getTravelers = async () => {
            setLoading(true);
            try {
                const travelersResults = await axios.get(profileTravelers, {
                    headers: {
                        Authorization: 'Bearer ' + state.token
                    }
                });
                if (travelersResults.status === 200) {
                    if (travelersResults.data.items.length === 0) {
                        setState({ ...state, errorMessage: 'در حال حاضر هیچ مسافری ثبت نشده است.', travelers: [] });
                        setLoading(false);
                    } else {
                        setState({ ...state, errorMessage: '', travelers: travelersResults.data.items });
                        setLoading(false);
                    }
                }
            } catch (error: any) {
                console.log(error);
                setLoading(false);
            }
        }
        if (state.showTravelersModal) {
            getTravelers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showTravelersModal]);
    const onSelectTraveler = (item: any) => {
        props.travelerParentCallback(item);
        setState({ ...state, showTravelersModal: false });
    }
    return (
        <div>
            <IonModal isOpen={state.showTravelersModal} mode="ios" cssClass="travelers-modal">
                <div>
                    <h3 className="travelers-modal-title">
                        لیست مسافرین قبلی شما
                        <IonIcon icon={close} onClick={() => setState({ ...state, showTravelersModal: false })} />
                    </h3>
                    {!loading ?
                        <div className="travelers-content">
                            <h5>
                                جهت استفاده از اطلاعات مسافرین این لیست ، مسافر مورد نظر را انتخاب نمایید
                            </h5>
                            {state.errorMessage.trim().length !== 0 ?
                                <div className="box-error">
                                    <IonImg src={warningSign} />
                                    <p>{state.errorMessage}</p>
                                </div>
                                :
                                <IonGrid className="travelers-table">
                                    <IonRow className="table-header">
                                        <IonCol size="6">
                                            نام مسافر
                                        </IonCol>
                                        <IonCol size="6" className="ion-text-end">
                                            عملیات
                                        </IonCol>
                                    </IonRow>
                                    {state.travelers.map((item: any, index: number) =>
                                        <IonRow className="table-item" key={"index" + index}>
                                            <IonCol size="6">
                                                {item.first_name + ' ' + item.last_name}
                                            </IonCol>
                                            <IonCol size="6" className="ion-text-end">
                                                <IonButton color="warning" onClick={() => onSelectTraveler(item)}>
                                                    انتخاب
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )}
                                </IonGrid>
                            }
                        </div>
                        :
                        <Loading />
                    }
                </div>
                <IonButton color="warning" onClick={() => setState({ ...state, showTravelersModal: false })} className="travelers-modal-close-btn">بستن</IonButton>
            </IonModal>
            <IonButton color="primary" expand="block" className="travelers-btn" onClick={() => setState({ ...state, showTravelersModal: true })}>
                <IonIcon icon={person} />
                انتخاب از مسافرین قبلی
            </IonButton>
        </div>
    );
};
export default Travelers;